import script from "./ShiftsView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShiftsView.vue?vue&type=script&setup=true&lang=ts"

import "./ShiftsView.vue?vue&type=style&index=0&id=a8d086e2&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a8d086e2"]])

export default __exports__